import styled from 'styled-components';

export const TotalWrapper = styled.div`
  margin: ${({ space = false }: { space?: boolean }) => (space ? '16px 0 16px' : '16px 0 0')};
  display: flex;

  & > div:first-child {
    margin-right: 4px;
    white-space: nowrap;
  }
  & > div:last-child {
    white-space: nowrap;
    margin-right: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FormWrapper = styled.div`
  position: relative;
`;
